import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

let cachedBranding = null;
const listeners = new Set();

export function useBranding() {
  const [branding, setBranding] = useState(cachedBranding);

  useEffect(() => {
    const onChange = (b) => setBranding(b);
    listeners.add(onChange);
    if (!cachedBranding) {
      api.get("/branding")
        .then((r) => {
          cachedBranding = r.data;
          listeners.forEach((fn) => fn(cachedBranding));
        })
        .catch(() => {});
    }
    return () => { listeners.delete(onChange); };
  }, []);

  const logoSrc = branding?.logo_path ? fileUrl(branding.logo_path) : null;
  return { branding, logoSrc };
}

export function refreshBranding() {
  return api.get("/branding").then((r) => {
    cachedBranding = r.data;
    listeners.forEach((fn) => fn(cachedBranding));
    return r.data;
  });
}
